export default "__VITE_ASSET__s7Co0Wgo__"